import React from 'react';
import { UNDO_BUTTON, REDO_BUTTON, UNDO_CHANGES_GROUP_RANK, UNDO_CHANGES_GROUP, REDO_CHANGES_GROUP_RANK, REDO_CHANGES_GROUP, TRACK_CHANGES_SECTION, TRACK_CHANGES_SECTION_RANK } from '@atlaskit/editor-common/toolbar';
import { RedoButton } from './RedoButton';
import { UndoButton } from './UndoButton';
export var getToolbarComponents = function getToolbarComponents(api) {
  return [{
    type: UNDO_CHANGES_GROUP.type,
    key: UNDO_CHANGES_GROUP.key,
    parents: [{
      type: TRACK_CHANGES_SECTION.type,
      key: TRACK_CHANGES_SECTION.key,
      rank: TRACK_CHANGES_SECTION_RANK[UNDO_CHANGES_GROUP.key]
    }]
  }, {
    type: UNDO_BUTTON.type,
    key: UNDO_BUTTON.key,
    parents: [{
      type: UNDO_CHANGES_GROUP.type,
      key: UNDO_CHANGES_GROUP.key,
      rank: UNDO_CHANGES_GROUP_RANK[UNDO_BUTTON.key]
    }],
    component: function component() {
      return /*#__PURE__*/React.createElement(UndoButton, {
        api: api
      });
    }
  }, {
    type: REDO_CHANGES_GROUP.type,
    key: REDO_CHANGES_GROUP.key,
    parents: [{
      type: TRACK_CHANGES_SECTION.type,
      key: TRACK_CHANGES_SECTION.key,
      rank: TRACK_CHANGES_SECTION_RANK[REDO_CHANGES_GROUP.key]
    }]
  }, {
    type: REDO_BUTTON.type,
    key: REDO_BUTTON.key,
    parents: [{
      type: REDO_CHANGES_GROUP.type,
      key: REDO_CHANGES_GROUP.key,
      rank: REDO_CHANGES_GROUP_RANK[REDO_BUTTON.key]
    }],
    component: function component() {
      return /*#__PURE__*/React.createElement(RedoButton, {
        api: api
      });
    }
  }];
};